module.exports = __webpack_public_path__ + "static/fonts/Mont-Black.0efaaa7.woff2";